import { Layout, Space } from 'antd'
import { createStyles } from 'antd-style'

import { PageSider } from '@eastcoal/common/components/Layout/PageSider'

import { RouterOutlet } from '@eastcoal/router/components/Outlet'
import { SiderMenu } from '@eastcoal/router/components/SiderMenu'
import { EastcoalLogo } from '@eastcoal/shared/components/EastcoalLogo'

import { HeaderAvatar } from '../components/HeaderAvatar'

const useStyles = createStyles(({ prefixCls, token }) => ({
  container: {
    height: '100vh',
    overflow: 'hidden'
  },
  header: {
    display: 'flex',
    flexFlow: 'row nowrap',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: 64,
    paddingInline: token.paddingMD,
    backgroundColor: token.colorBgBase,
    borderBottom: `1px solid ${token.colorBorder}`
  },
  main: {
    position: 'relative',
    height: '100%',
    overflow: 'auto'
  },
  // 多包一层，防止 main 的 padding 会影响到子元素的 sticky 定位
  content: {
    height: '100%',
    paddingInline: token.paddingSM,
    paddingBlock: token.paddingXS,
    ['.page-container-breadcrumb']: {
      paddingBlockEnd: token.paddingXS
    }
  },
  menu: {
    // 第一层父节点加粗
    [`&:first-of-type >li `]: {
      [`>div >.${prefixCls}-menu-title-content,
        >.${prefixCls}-menu-title-content`]: {
        fontWeight: token.fontWeightStrong
      }
    }
  }
}))

/**
 * 管理系统风格的布局
 */
export const ConsoleLayout = () => {
  const { styles } = useStyles()

  return (
    <Layout className={styles.container}>
      <Layout.Header className={styles.header}>
        <EastcoalLogo link='/' />
        <Space>
          <HeaderAvatar />
          {/* <MessageNotification /> */}
        </Space>
      </Layout.Header>
      <Layout hasSider>
        <PageSider>
          <SiderMenu className={styles.menu} />
        </PageSider>
        <Layout.Content className={styles.main}>
          <div className={styles.content}>
            <RouterOutlet />
          </div>
        </Layout.Content>
      </Layout>
    </Layout>
  )
}
